export default __webpack_public_path__ + "static/media/courseAssign.790d42aa.png";